import { css } from '@linaria/core';
import { VStack } from '@cbhq/cds-web/layout';
import { FullscreenModal } from '@cbhq/cds-web/overlays/Modal/FullscreenModal';
import { ThemeProvider } from '@cbhq/cds-web/system';
import { TextBody, TextDisplay3 } from '@cbhq/cds-web/typography';

import bottle from ':cloud/widgets/buildQuest/assets/bottle.png';
// placeholder images
import shirt from ':cloud/widgets/buildQuest/assets/shirt.png';
import sock from ':cloud/widgets/buildQuest/assets/sock.png';
import tote from ':cloud/widgets/buildQuest/assets/tote.png';
import { Carousel, CarouselItem } from ':cloud/widgets/buildQuest/PrizesCarousel';

// mock data
const items: CarouselItem[] = [
  {
    id: 1,
    name: 'CDP T-Shirt',
    imageUrl: shirt,
    isLocked: false,
    requiredLevel: 1,
  },
  {
    id: 2,
    name: 'CDP Bottle',
    imageUrl: bottle,
    isLocked: true,
    requiredLevel: 2,
  },
  {
    id: 3,
    name: 'CDP Socks',
    imageUrl: sock,
    isLocked: true,
    requiredLevel: 3,
  },
  {
    id: 4,
    name: 'CDP Tote',
    imageUrl: tote,
    isLocked: true,
    requiredLevel: 4,
  },
];

const modalContainer = css`
  padding: 0;
  margin: 0;
  overflow: hidden;
  .fsm-primary-content-container {
    padding: 0;
  }
`;

interface BuildQuestPrizesProps {
  visible: boolean;
  handleClose: () => void;
}

export function BuildQuestPrizes({
  visible,
  handleClose,
}: BuildQuestPrizesProps): React.ReactElement {
  const primaryContent = (
    <VStack width="100vw" height="100%" alignItems="center" position="relative" gap={8}>
      <VStack gap={2} alignItems="center" width="100%" spacing={2}>
        <TextDisplay3 as="h3">CDP Quest Prizes</TextDisplay3>

        <TextBody as="p" color="foregroundMuted" align="center">
          Complete challenges, get exp to level up, and unlock rewards each level.
          <br />
          To claim your rewards, come see the CDP team in Building 4, Floor 3.
        </TextBody>
      </VStack>

      <Carousel items={items} />
    </VStack>
  );

  return (
    <ThemeProvider scale="large" spectrum="dark">
      <FullscreenModal
        hideDivider
        visible={visible}
        dangerouslySetContentClassName={modalContainer}
        logo={<div />}
        onRequestClose={handleClose}
        primaryContent={primaryContent}
        closeAccessibilityLabel="Close"
      />
    </ThemeProvider>
  );
}
